import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Kicks off a Stripe subscription checkout for a given membership tier.
// lookupKey values live in src/data/tiers.js for easy editing.
export async function startCheckout(lookupKey, setLoading) {
  try {
    if (setLoading) setLoading(true);
    const res = await axios.post(`${API}/payments/checkout`, {
      lookup_key: lookupKey,
      origin_url: window.location.origin,
    });
    const { checkout_url } = res.data;
    if (checkout_url) {
      window.location.href = checkout_url;
    } else {
      throw new Error("No checkout URL returned");
    }
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.error("Checkout error", e);
    const detail = e?.response?.status === 409 ? e.response.data?.detail : null;
    toast.error(detail || "Unable to start checkout. Please try again.");
    if (setLoading) setLoading(false);
  }
}
